import { loadable } from 'utils';

export const CreateExpress = loadable(() => import('./CreateExpress'), {});
export const InviteSignUp = loadable(() => import('./InviteSignUp'), {});
export const ImportWizard = loadable(() => import('./ImportWizard'), {});
export const ChannelProfile = loadable(() => import('./ChannelProfile'), {});
export const SiteProfile = loadable(() => import('./SiteProfile'), {});
export const Update = loadable(() => import('./Update'), {});
